import React from "react";
import { X } from "@phosphor-icons/react";

export const ReceiptDrawer = ({ open, onClose, receipts }) => {
  return (
    <>
      <div
        className={`fixed inset-0 bg-stone-900/20 transition-opacity duration-300 z-40 ${
          open ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={onClose}
      />
      <aside
        data-testid="receipt-drawer"
        className={`fixed inset-y-0 right-0 w-[440px] bg-stone-50 border-l border-stone-200 shadow-2xl z-50 transform transition-transform duration-300 ease-out ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="h-16 px-5 border-b border-stone-200 flex items-center justify-between bg-white">
          <div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-stone-500">
              KATLAS · Decision records
            </div>
            <div className="text-base font-medium text-stone-900">Governed action history</div>
          </div>
          <button
            data-testid="close-receipts"
            onClick={onClose}
            className="p-1.5 hover:bg-stone-100 rounded-sm"
          >
            <X size={16} />
          </button>
        </div>

        <div className="overflow-y-auto h-[calc(100%-4rem)] p-5 space-y-3 scroll-soft">
          {receipts.length === 0 ? (
            <div className="text-sm text-stone-500 text-center py-12 leading-relaxed">
              No receipts yet.
              <br />
              <span className="text-xs text-stone-400">Run a request to generate a decision card.</span>
            </div>
          ) : (
            receipts.map((r) => (
              <div
                key={r.id + r.issuedAt}
                data-testid={`receipt-${r.id}`}
                className="bg-[#FFFCF8] border border-dashed border-stone-300 rounded-sm p-3 paper-texture relative overflow-hidden"
              >
                <div className="relative z-10">
                  <div className="flex items-start justify-between border-b border-stone-200 pb-1.5">
                    <div>
                      <div className="text-[10px] uppercase tracking-wider text-stone-500">
                        Decision
                      </div>
                      <div className="font-mono text-[11px] text-stone-900">{r.id}</div>
                    </div>
                    <div className="font-mono text-[10px] text-stone-500">
                      {new Date(r.issuedAt).toLocaleTimeString()}
                    </div>
                  </div>
                  <div className="text-sm font-medium text-stone-900 mt-1.5 leading-snug">
                    {r.requestTitle}
                  </div>
                  <div className="text-[11px] text-stone-600 mt-0.5">
                    {r.requestingRole} · {r.proposedAction}
                  </div>
                  <div className="grid grid-cols-2 gap-2 mt-2 font-mono text-[10px]">
                    <Stat k="route" v={r.modelRoute} />
                    <Stat k="cost/1k" v={`$${r.cost.toFixed(4)}`} />
                    <Stat k="auth" v={r.authorityState} />
                    <Stat k="status" v={r.status} />
                  </div>
                  <div className="mt-2 pt-1.5 border-t border-stone-200 text-[10px] text-stone-500 leading-relaxed">
                    {r.disclosurePolicy}
                  </div>
                </div>
                <div className="absolute bottom-1 right-1.5 text-[9px] uppercase tracking-[0.16em] text-emerald-700/70 font-medium">
                  Attributable
                </div>
              </div>
            ))
          )}
        </div>
      </aside>
    </>
  );
};

const Stat = ({ k, v }) => (
  <div className="flex items-baseline gap-1.5">
    <span className="text-stone-400 uppercase tracking-wider">{k}</span>
    <span className="text-stone-800 break-words">{v}</span>
  </div>
);
